
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';

// https://apphub-workspace.slack.com/archives/C06E17VT9RT/p1717056993061469
export const DASHBOARD_V4_EXTERNAL_RELEASE_DATE = '2024-05-30T15:16:00+07:00';

export const DASHBOARD_V4_POSITION = {
  TOP: 0,
  FIRST: 1,
  SECOND: 2
};

export const DASHBOARD_V4_LAYOUT_TOP = () => {
  return [['marketingBanner'], ['welcome3'], ['appInsight'], ['upgradeTurbo']];
};

export const DASHBOARD_V4_LAYOUT_FIRST_COLUMN = ({ isTrial, isFreemium }) => {
  if (isTrial)
    return [
      ['notifications'],
      ['quickStartGuide'],
      ['planSubscription'],
      ['marketingMiddleBanner'],
      ['boostInsightHub']
    ];
  if (isFreemium)
    return [
      ['notifications'],
      ['csatRating'],
      ['planSubscription'],
      ['quickStartGuide'],
      ['marketingMiddleBanner'],
      ['boostInsightHub']
    ];
  return [
    ['notifications'],
    ['planSubscription'],
    ['quickStartGuide'],
    ['marketingMiddleBanner'],
    ['boostInsightHub']
  ];
};

export const DASHBOARD_V4_LAYOUT_SECOND_COLUMN = ({ isTrial, isFreemium }) => {
  if (isFreemium) return [['syncHookStatus'], ['changeLogs'], ['getSupport'], ['recommendedApps']];
  if (isTrial) return [['syncHookStatus'], ['changeLogs'], ['getSupport']];
  return [['syncHookStatus'], ['changeLogs'], ['getSupport'], ['recommendedApps']];
};

export const FeaturesKYC = {
  PRODUCT_FILTER: 'PRODUCT_FILTER',
  PRODUCT_SEARCH: 'PRODUCT_SEARCH',
  VISUAL_MERCHANDISING: 'VISUAL_MERCHANDISING',
  PRODUCT_RECOMMENDATION: 'PRODUCT_RECOMMENDATION'
};

export const AI_POWERED_SEARCH = 'AI-powered-search';
export const AI_POWERED_RECOMMENDATION = 'AI-powered-recommendation';
export const COLLECTION_MERCHANDISING = 'collection-merchandising';
export const VARIANT_DISPLAY = 'variant-display';

export const PACKAGE = {
  basic: 'basic',
  essential: 'essential',
  professional: 'professional'
};

export const TYPES = {
  ADD_ON: 'add-on',
  FEATURE: 'feature'
};

export const FEATURES = {
  ANALYTICS: 'Analytics',
  MERCHANDISING: 'Merchandising',
  RECOMMENDATION: 'Recommendation',
  SWATCH_SETTINGS: 'SwatchSettings',
  INSTANT_SEARCH_DISPLAY: 'InstantSearchDisplay',
  AI_SYNONYMS: 'AISynonyms',
  MANAGE_FILTER_TREE: 'ManageFilterTree'
};

export const DEFAULT_MAPPING_UPSELL = {
  // 1 feature, package Basic
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.basic}`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.basic}`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.basic}`]: [
    { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
  ],
  // 1 feature, package Essential
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.essential}`]: [
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.essential}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
  ],
  // 1 feature, package Professional
  [`${[FeaturesKYC.PRODUCT_SEARCH].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_FILTER].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],
  [`${[FeaturesKYC.PRODUCT_RECOMMENDATION].join('+')}_${PACKAGE.professional}`]: [
    { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
    { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
    { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
    { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
    { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
    { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
  ],

  // 2 features, package Basic
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${PACKAGE.basic}`]:
    [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.basic
    }`]: [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.basic
    }`]: [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.basic
    }`]: [
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.basic
    }`]: [
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.basic
    }`]: [
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON }
    ],
  // 2 features, package Essential
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: FEATURES.SWATCH_SETTINGS, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.essential
    }`]: [
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  // 2 features, package Professional
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.VISUAL_MERCHANDISING, FeaturesKYC.PRODUCT_RECOMMENDATION].sort().join('+')}_${PACKAGE.professional
    }`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],

  // 3 features, package Basic
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON }
    ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE }
    ],
  // 3 features, package Essential
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
    ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON }
    ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE },
      { name: VARIANT_DISPLAY, type: TYPES.ADD_ON }
    ],
  // 3 features, package Professional
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.VISUAL_MERCHANDISING]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[FeaturesKYC.PRODUCT_FILTER, FeaturesKYC.PRODUCT_SEARCH, FeaturesKYC.PRODUCT_RECOMMENDATION]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  [`${[
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],

  // 4 features, package Basic
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.basic}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: AI_POWERED_SEARCH, type: TYPES.ADD_ON },
      { name: AI_POWERED_RECOMMENDATION, type: TYPES.ADD_ON },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE }
    ],
  // 4 features, package Essential
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.essential}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: COLLECTION_MERCHANDISING, type: TYPES.ADD_ON },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ],
  // 4 features, package Professional
  [`${[
    FeaturesKYC.PRODUCT_FILTER,
    FeaturesKYC.PRODUCT_SEARCH,
    FeaturesKYC.VISUAL_MERCHANDISING,
    FeaturesKYC.PRODUCT_RECOMMENDATION
  ]
    .sort()
    .join('+')}_${PACKAGE.professional}`]: [
      { name: FEATURES.INSTANT_SEARCH_DISPLAY, type: TYPES.FEATURE },
      { name: FEATURES.AI_SYNONYMS, type: TYPES.FEATURE },
      { name: FEATURES.RECOMMENDATION, type: TYPES.FEATURE },
      { name: FEATURES.ANALYTICS, type: TYPES.FEATURE },
      { name: FEATURES.MERCHANDISING, type: TYPES.FEATURE },
      { name: FEATURES.MANAGE_FILTER_TREE, type: TYPES.FEATURE }
    ]
};

export const PARTNERS_POWERUP = [
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_reviewio_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_reviewio_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.reviewio),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.reviewio)
    },
    link: 'https://apps.shopify.com/reviews-co-uk-product-and-merchant-review-collection'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_influence_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_influence_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.influence),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.influence)
    },
    link: 'https://apps.shopify.com/influence-io'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_viral_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_viral_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.viral),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.viral)
    },
    link: 'https://apps.shopify.com/viralsweep'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_address_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_address_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.address),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.address)
    },
    link: 'https://apps.shopify.com/address-validator'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_richreturn_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_richreturn_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.richreturn),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.richreturn)
    },
    link: 'https://apps.shopify.com/rich-returns'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_honey_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_honey_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.honey),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.honey)
    },
    link: 'https://apps.shopify.com/honeycomb-upsell-funnels'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_appikon_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_appikon_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.appikon),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.appikon)
    },
    link: 'https://apps.shopify.com/pre-order-today'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_bundle_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_bundle_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.bundle),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.bundle)
    },
    link: 'https://apps.shopify.com/bundles-bear'
  },
  {
    name: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_ultimate_title',
    detail: 'AdminHTML.DashboardV3.RecommendedAppsV2.app_ultimate_description',
    logo: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.ultimate),
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.partners?.ultimate)
    },
    link: 'https://apps.shopify.com/ultimate-sticky-add-to-cart?st_source=autocomplete'
  }
];

export const DATA_UPSELL = {
  [AI_POWERED_SEARCH]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.addonSearch),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonSearch_btn',
    isHasAI: true
  },
  [AI_POWERED_RECOMMENDATION]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.addonRec),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonRec_btn',
    isHasAI: true
  },
  [COLLECTION_MERCHANDISING]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.addonCol),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonCol_btn',
    isHasAI: false
  },
  [VARIANT_DISPLAY]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.addonVariant),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.AddonVariant_btn',
    isHasAI: false
  },
  [FEATURES.ANALYTICS]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fAnalytic),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FAnalytic_btn',
    isHasAI: false
  },
  [FEATURES.MERCHANDISING]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fMerchan),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FMerchan_btn',
    isHasAI: false
  },
  [FEATURES.RECOMMENDATION]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fRec),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FRec_btn',
    isHasAI: false
  },
  [FEATURES.SWATCH_SETTINGS]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fSwatch),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSwatch_btn',
    isHasAI: false
  },
  [FEATURES.INSTANT_SEARCH_DISPLAY]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fInstant),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FInstant_btn',
    isHasAI: false
  },
  [FEATURES.AI_SYNONYMS]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fSynonym),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FSynonym_btn',
    isHasAI: true
  },
  [FEATURES.MANAGE_FILTER_TREE]: {
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.fFilter),
    title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter',
    label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter_label',
    btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.FFilter_btn',
    isHasAI: false
  }
};

export const DATA_UPSELL_ITEM_STORE = {
  name: 'store',
  icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.dashboardV3?.iconsUpsell?.store),
  title: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store',
  label: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store_label',
  btn: 'AdminHTML.DashboardV3.CrossSellUpSellV2.Store_btn'
};

export const BOOST_APP_SHOPIFY_REVIEW_URL =
  'https://apps.shopify.com/product-filter-search#modal-show=ReviewListingModal';

export const REMOVE_GUIDE_NEW_SI = [
  'V2_SEARCH2',
  'V2_FILTER2',
  // 'V2_FILTER4_ADVANCED',
  // 'V2_FILTER5_ADVANCED',
  'V2_RECOMMEND1',
  'V2_PREVIEW1'
];

// User installed after 12/11/2024 is new user (staging)   // 1731369600
// User installed after 08/01/2025 is new user (production) // 1736294400

const isStaging = process.env.REACT_APP_ENV === 'staging';
export const RELEASE_SIMPLIFY_DATE = isStaging ? 1731369600 : 1736294400;

export const FREEMIUM_3MONTHS_COUPON_VALIDITY_DAYS = 14;
export const FREEMIUM_MONTH_COUPON_VALIDITY_DAYS = 28;

export const FREEMIUM_TOP_CAMPAIGN_BANNER = [
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignFilterTree_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignFilterTree_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignFilterTree),
    link: 'https://support.boostcommerce.net/en/collections/8474165-filter'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignMerchandising_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignMerchandising_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignMerchandising),
    link: 'https://support.boostcommerce.net/en/collections/9436965-merchandising'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPremiumFeatures_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPremiumFeatures_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignPremiumFeatures),
    link: 'https://support.boostcommerce.net/en/collections/9436961-search'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignSemanticSearch_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignSemanticSearch_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignSemanticSearch),
    link: 'https://support.boostcommerce.net/en/articles/9360380-semantic-search'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignAiSynonym_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignAiSynonym_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignAiSynonym),
    link: 'https://support.boostcommerce.net/en/articles/9360371-how-to-enable-ai-synonym-search'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPerformanceRanking_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPerformanceRanking_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignPerformanceRanking),
    link: 'https://support.boostcommerce.net/en/articles/9360384-product-performance-ranking'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPersonalization_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPersonalization_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignPersonalization),
    link: 'https://support.boostcommerce.net/en/articles/9360388-search-personalization'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignRecommendation_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignRecommendation_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignRecommendation),
    link: 'https://support.boostcommerce.net/en/articles/9400263-basic-flow-to-set-up-a-boost-recommendation-widget'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPreOrder_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignPreOrder_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignPreOrder),
    link: 'https://support.boostcommerce.net/en/articles/10050875-how-to-use-pre-order-campaigns'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaign3rdIntegration_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaign3rdIntegration_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaign3rdIntegration),
    link: 'https://support.boostcommerce.net/en/collections/9461876-third-party-app-integration'
  },
  {
    title: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignGeneralSettings_Title',
    content: 'AdminHTML.DashboardV3.Campaign.FreemiumCampaignGeneralSettings_Content',
    source: getAssetURL(ADMIN_APP_ASSET_PATHS.campaigns.freemiumCampaignGeneralSettings),
    link: 'https://support.boostcommerce.net/en/collections/9436970-tool'
  }
];
